import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import AppShell from "../components/AppShell";
import { Trophy } from "@phosphor-icons/react";

export default function Leaderboard() {
  const [leaders, setLeaders] = useState(null);

  useEffect(() => {
    api.get("/leaderboard?limit=50").then((r) => setLeaders(r.data));
  }, []);

  return (
    <AppShell>
      <div className="max-w-4xl mx-auto" data-testid="leaderboard-page">
        <div className="label-mono mb-2" style={{ color: "#FFAB00" }}>RANKINGS · ALL TIME</div>
        <div className="flex items-center gap-3 mb-2">
          <Trophy size={40} weight="light" style={{ color: "#FFAB00" }} />
          <h1 className="font-display text-white" style={{ fontSize: 48, fontWeight: 900, letterSpacing: "-0.035em" }}>
            Leaderboard
          </h1>
        </div>
        <p className="text-zinc-400 mb-10">Points awarded for posts (10), video/voice posts (+5 bonus) and replies (5).</p>

        {leaders === null ? (
          <div className="py-12 text-center label-mono"><span className="spinner mr-2 align-middle" />LOADING...</div>
        ) : (
          <div className="border border-[#27272A]" data-testid="leaderboard-list">
            <div className="grid grid-cols-12 px-5 py-3 label-mono bg-[#121214] border-b border-[#27272A]">
              <div className="col-span-1">#</div>
              <div className="col-span-5">Member</div>
              <div className="col-span-2">Role</div>
              <div className="col-span-2 text-right">Level</div>
              <div className="col-span-2 text-right">XP</div>
            </div>
            {leaders.map((u, i) => (
              <Link key={u.id} to={`/profile/${u.id}`}
                className="grid grid-cols-12 px-5 py-4 border-b border-[#27272A] last:border-0 hover:bg-[#121214] transition-colors items-center"
                data-testid={`leaderboard-row-${i}`}
              >
                <div className="col-span-1 font-display text-2xl" style={{ fontWeight: 900, color: i < 3 ? "#E60012" : "#3F3F46" }}>
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-5 flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 bg-[#27272A] flex items-center justify-center font-display text-white">{u.name[0]}</div>
                  <div className="min-w-0">
                    <div className="text-white text-sm font-medium truncate">{u.name}</div>
                    <div className="label-mono mt-0.5 truncate" style={{ fontSize: 9 }}>{u.email}</div>
                  </div>
                </div>
                <div className="col-span-2">
                  {u.role !== "public" && <span className={`role-badge ${u.role}`}>{u.role}</span>}
                </div>
                <div className="col-span-2 text-right font-mono text-white">LVL {u.level}</div>
                <div className="col-span-2 text-right font-mono text-white font-bold">{u.points}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
